import { Sliders } from "@phosphor-icons/react";
import React from "react";
import Slider from "react-slick";



const ReviewBottom = () => {

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }
    function SamplePrevArrow(props) {
        const { className, onClick } = props;

        return (

            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle bg-white text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    const settings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 3,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                },
            },

        ],
    };


    return (
        <div className="reviewbottom">
            <div className="container">
                <div>
                    <h5 className="text-center mt-50 mb-20 text-white">Review That Speaks Volume</h5>
                <span className="subtitle">Discover what makes QuickBooks Online the #1 accounting software for small businesses.</span>
                <div className="card position-relative reviewtopcontainer  border-0" style={{minHeight:"434px", padding:"36px 0px"}}>
                    <Slider {...settings} style={{zIndex:"1"}}>

                        <div className="shopReview">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-center">
                                    <div className="shopLogo">
                                        <img src="assets/images/thumbs/ferrari.png" className="mx-auto"></img>
                                    </div>
                                    <div className="shopName ">Shop Name</div>
                                    <div className="d-flex justify-content-center align-items-center starsReview">
                                        <i class="ph-fill ph-star"></i>
                                        <i class="ph-fill ph-star"></i>
                                        <i class="ph-fill ph-star"></i>
                                        <i class="ph-fill ph-star"></i>
                                        <i class="ph-fill ph-star"></i>
                                    </div>
                                    <div className="reviewsCountShop">5.0 (8,172 reviews)</div>
                                    <a className="link">Read all reviews</a>
                                </div>
                                
                            </div>
                            
                        </div>
                        <div className="personalReview">
                             <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="text-center">
                                        <div className="name">John Doe</div>
                                        <div className="d-flex justify-content-center align-items-center starsReview personal">
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                        </div>
                                        <span>“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.”</span>
                                </div>
                                     
                             </div> 
                           
                        </div>
                        <div className="personalReview">
                            <div className="d-flex justify-content-center align-items-center  h-100">
                                     <div className="text-center">
                                        <div className="name">John Doe</div>
                                        <div className="d-flex justify-content-center align-items-center starsReview personal">
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                            <i class="ph-fill ph-star"></i>
                                        </div>
                                        <span>“Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.”</span>
                                </div>
                             </div>
                        </div> 
                    </Slider>
                </div>
                </div>
                
            </div>
        </div>

    )
}


export default ReviewBottom;